export default __webpack_public_path__ + "static/media/failedVerification.e0130e0b.svg";